<template>
  <div id="tramiteNuevo">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Trámite / Finaliza
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-card class="elevation-0">
        <v-card-title class="lighten-3">
          <span class=""><b>Tipo de Trámites:</b> {{ tramites }}</span>
          <v-spacer></v-spacer>
          <v-btn outline color="primary" small @click="showInfo = !showInfo">{{ showInfo?'Ocultar': 'Mostrar' }} Datos</v-btn>
        </v-card-title>
        <v-card-text v-if="showInfo==true">
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="tarea.evaluacion"
            class="elevation-1"
            hide-actions
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>
                <span v-html="props.item.pregunta"></span>
              </td>
              <td>
                {{ props.item.si==true?'X':'' }}
              </td>
              <td>
                {{ props.item.no==true?'X':'' }}
              </td>
              <td>
                {{ props.item.observacion }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <br>
      <v-card>
        <v-card-title class="headline lighten-3">
          <span class="headline">Finalizar Trámite</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form_finaliza">
            <v-layout row wrap>
              <v-flex xs12 sm6 class="my-0">
                <v-text-field
                  label="Número R.M."
                  v-model="numero_rm"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="my-0">
                <v-menu
                  v-model="fechaRm"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_rm"
                      label="Fecha R.M."
                      append-icon="event"
                      :rules="[v => !!v || 'El campo es requerido']"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha_rm" @input="fechaRm = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 class="my-0">
                <v-text-field
                  label="Resolución Ministerial"
                  @click="pickFile"
                  v-model="resolucion_ministerial"
                  append-icon="attach_file"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="informe"
                  accept="application/pdf"
                  @change="onFilePicked"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="confirmTramite">
            Guardar
          </v-btn>
          <v-btn color="red" dark @click="waitTramite">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="cdialog" persistent max-width="300px">
        <v-form ref="form">
          <v-card>
            <v-card-title class="headline grey lighten-3">
              <span class="headline">Alerta</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text-xs-center">
              <span :class="color_txt + '--text text--darken-2 subheading'">
                {{ mensaje }}
              </span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="loadingBtnSend" v-if="hide_accept && type_action" color="success darken-1" flat @click.native="sendTramite">
                Aceptar
              </v-btn>
              <v-btn :loading="loadingBtnSend" v-if="!type_action" color="success darken-1" flat @click.native="redirect">
                Aceptar
              </v-btn>
              <v-btn color="blue darken-1" flat @click.native="closeDialog">
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2800"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
import { truncate } from 'fs';
export default {
  name: "filtro-departamental",
  data: () => ({
    showInfo: false,
    headers: [
      { text: 'Nro', align: 'left', sortable: false, width: '6%' },
      { text: 'Requisitos ', sortable: false, width: '46%' },
      { text: 'Si', sortable: false, width: '6%' },
      { text: 'No', sortable: false, width: '6%' },
      { text: 'Observaciones', sortable: false, width: '36%' }
    ],
    fechaRm: false,
    loading: false,
    loadingBtnSend: false,
    cdialog: false,
    hide_accept: false,
    color_txt: '',
    mensaje: '',
    dparams: {},
    numero_rm: '',
    fecha_rm: '',
    resolucion_ministerial: '',
    archivo_rm: '',
    informe_final: '',
    archivo_if: '',
    requisitos: [],
    tipo_tramite: [],
    institucioneducativa_id: '',
    tramites: '',
    tarea: '',
    type_action: false,
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 3000,
      text: ""
    }
  }),
  created() {
    if (Service.getTramiteId() == null) {
      this.$router.push('/tramite/recibido');
    } else {
      this.getDatos();
    }
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().nacional) {
      this.$router.push({name: 'principal'});
    }
  },
  methods: {
    pickFile() {
      this.$refs.informe.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].size < 2057157) {
          this.resolucion_ministerial = files[0].name;
          this.archivo_rm = files[0];
        } else {
          this.$refs.informe.value = '';
          this.resolucion_ministerial = '';
          this.archivo_rm = '';
          this.toast('warning', 'El archivo no debe superar el peso permitido de <b>2MB</b>.');
        }
      } else {
        this.resolucion_ministerial = '';
        this.archivo_rm = '';
      }
    },
    getDatos() {
      axios
        .get(Service.getBase() + "tramite/tarea/4/" + Service.getTramiteId(), Service.getHeader())
        .then(response => {
          //this.tipo_tramite = response.data;
          if (response.data.datos !='') {
            this.tarea = JSON.parse(response.data.datos);
            this.institucioneducativa_id = this.tarea.institucioneducativa_id;
            this.tipo_tramite = this.tarea.tipo_tramite;
            var cantidad_tramites = (this.tarea.tipo_tramite.length-1);
            for (var key in this.tarea.tipo_tramite) {
              let tramite_nombre = '';
              switch (this.tarea.tipo_tramite[key]) {
                case 2:
                  tramite_nombre = 'Ratificación';
                  break;
                case 3:
                  tramite_nombre = 'Ampliación';
                  break;
                case 4:
                  tramite_nombre = 'Cambio de Razón Social';
                  break;
                case 5:
                  tramite_nombre = 'Cambio de Domicilio';
                  break;
                case 6:
                  tramite_nombre = 'Cambio de derecho Propietario';
                  break;
                default:
                  tramite_nombre = 'Apertura';
                  break;
              }
              this.tramites += tramite_nombre+(key < cantidad_tramites?', ':'');
            }
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    confirmTramite() {
      this.color_txt = 'grey';
      this.mensaje = '¿Esta seguro(a) de finalizar el trámite con la información ingresada?';
      this.loadingBtnSend = false;
      this.type_action = true;
      this.hide_accept = true;
      if (this.$refs.form_finaliza.validate()) {
        this.cdialog = true;
      }
    },
    sendTramite() {
      this.loadingBtnSend = true;
      this.dparams = Service.getParams();
      this.dparams.tipo_tramite = this.tipo_tramite;
      this.dparams.ie_id = this.institucioneducativa_id;
      this.dparams.tramite_id = Service.getTramiteId();
      var fd = new FormData();
      fd.append('params', JSON.stringify(this.dparams));
      fd.append('numero_rm', this.numero_rm);
      fd.append('fecha_rm', this.fecha_rm);
      fd.append('resolucion_ministerial', this.archivo_rm);
      // fd.append('informe_final', this.archivo_if);
      axios
        .post(Service.getBase() + 'finaliza/nacional', fd, {
          headers: {
            'Content-Type': 'multipart/form-data', 'Authorization': Service.getToken()
          }
        })
        .then(response => {
          this.loadingBtnSend = false;
          if (response.data.estado == 200) {
            this.color_txt = 'success';
            this.hide_accept = false;
            this.$refs.form_finaliza.reset();
            this.archivo_rm = null;
            // localStorage.removeItem("itr");
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.mensaje = response.data.msg;
        })
        .catch(error => {
          this.loadingBtnSend = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.mensaje = "No se pudo registrar el trámite";
          console.error("Error al guardar", error);
        });
    },
    closeDialog() {
      if (this.hide_accept == false) {
        this.$router.push({name: 'tramite/recibido'});
      }
      this.cdialog = false;
    },
    waitTramite() {
      this.color_txt = 'grey';
      this.mensaje = '¿Está segura(o) de posponer el trámite? Puede retomar el trámite en la bandeja de recibidos.';
      this.hide_accept = true;
      this.type_action = false;
      this.cdialog = true;
    },
    redirect() {
      this.$router.push({name: 'tramite/recibido'});
    },
    formularioRcctp() {
      //axios.get(Service.getBase() + 'tramite/imprime/1/'+ Service.getTramiteId()).then(response => {
      axios.get(Service.getBase() + 'tramite/imprime/1/1671369').then(response => {
        var datos = JSON.parse(response.data.datosTarea2.datos);
        var myDataCursos = [];
        //{text: 'N°', style: 'tableHeader', alignment: 'center', fillColor: '#e0e3e5', fontSize: 9.5}, 
        myDataCursos.push([{text: 'CURSOS DE CAPACITACIÓN', style: 'tableHeader'}, {text: 'RÉGIMEN DE ESTUDIOS', style: 'tableHeader'}, {text: 'CARGA HORARIA', style: 'tableHeader'}, {text: 'CERTIFICACIÓN', style: 'tableHeader'}]);
        for (const key in datos.cursos_capacitacion) {
          myDataCursos.push([{text: datos.cursos_capacitacion[key].curso_nombre}, {text: 'Mensual', alignment: 'center'}, {text: datos.cursos_capacitacion[key].carga_horaria, alignment: 'center'}, {text: ''}]);
        }
        var docDefinition = {
          pageMargins: Service.pdfSetting().pMargin,
          pageSize: Service.pdfSetting().pSize,
          pageOrientation: Service.pdfSetting().pOrientation,
          defaultStyle : Service.pdfSetting().defStyle,
          header: Service.pdfSetting().myheaderF('RCCTP'),
          footer: Service.pdfSetting().myfooter,
          styles: Service.pdfSetting().mystyle,
          content: [
            { text: "DATOS GENERALES", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "NOMBRE/RAZÓN SOCIAL:",
                  bold : true,
                  margin: [0, 2, 0, 4],
                },
                {
                  width: "75%",
                  text: datos.institucional.nombre,
                  margin: [0, 2, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "DEPARTAMENTO:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "48%",
                  text: datos.institucional.departamento_nombre,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "7%",
                  text: "NIT:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "30%",
                  text: '56489752463',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "SEDE CENTRAL Y/O SUBSEDE:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: (datos.institucional.sede_central==true) ? 'SEDE CENTRAL' : 'SUBSEDE',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "DIRECCIÓN:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: datos.institucional.direccion,
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "ZONA:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: datos.institucional.zona,
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "PROPIETARIA/O - REPRESENTANTE LEGAL:",
                  bold : true,
                  margin: [0, 2, 0, 12],
                },
                {
                  width: "75%",
                  text: datos.propietario.nombre+' '+datos.propietario.paterno+' '+datos.propietario.materno,
                  margin: [0, 2, 0, 12],
                }
              ]
            },
            { text: "DATOS TÉCNICOS", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "CURSOS AUTORIZADOS:",
                  bold : true,
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "48%",
                  text: '',
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "7%",
                  text: "AREA:",
                  bold : true,
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "30%",
                  text: 'COMERCIAL',
                  margin: [0, 4, 0, 12],
                }
              ]
            },
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: ['35%','20%','15%','30%'],
                body: myDataCursos
              }
            },
            { text: "VIGENCIA", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "RESOLUCIÓN MINISTERIAL:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: 'N° 0988/2019',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "FECHA DE EMISIÓN:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "30%",
                  text: '20/10/2019',
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "25%",
                  text: "FECHA DE VENCIMIENTO:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "20%",
                  text: '20/10/2024',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              stack: [
                { canvas: [{ type: 'line', x1: 360, y1: 50, x2: 190, y2: 50 }] },
                { text: 'VICIMINISTRO/A DE EDUCACIÓN\nALTERNATIVA Y ESPECIAL', bold : true, alignment: 'center', margin: [0, 4, 0, 0]},
              ]
            },
            { text: "EL PRESENTE DOCUMENTO DEBE SER EXHIBIDO EN LUGAR VISIBLE DEL CCTP", bold : true, alignment: 'center', fontSize: 9, margin: [0, 20, 0, 0] }
          ]
        };
        pdfMake.createPdf(docDefinition).open();
        // pdfMake.createPdf(docDefinition).download("FiltroNacional.pdf");
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>